import React from "react";
import { useCan } from "../../../hooks/useCan";

export const Can = ({ children, permissions = [""], some = false }) => {
    const userCanSeeComponent = useCan({ permissions, some });

    if (!userCanSeeComponent) {
        return null;
    }

    return <>{children}</>;
};
